import API_BASE from '../apiBase';
import axios from 'axios';

// Create checkout session via backend (Razorpay)
export const createCheckoutSession = async (planId, billingCycle) => {
  const { data } = await axios.post(`${API_BASE}/api/checkout/session`, {
    plan_id: planId,
    billing_cycle: billingCycle,
    success_url: `${window.location.origin}/plans?payment=success`,
    cancel_url: `${window.location.origin}/plans?payment=cancelled`,
  });
  return data;
};



